import React, { Component, createRef } from "react";

import { Button, Card, Container, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
class ExternalLedgerPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    document.title = "admin-report-external";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t('Ledger')} />
            <Card className="pb-5">
              <div>
                <div className="d-lg-flex d-block text-lg-start text-center justify-content-between px-0 px-lg-3 pt-3 pb-2">
                  <div>
                    <h3 className="text-black fw-bold">Ledger </h3>
                  </div>
                  {/* <div className="text-lg-end text-center">
                    <label
                      htmlFor="date"
                      className="fs-5 fw-bold text-black pe-3"
                    >
                      Date:
                    </label>
                    <input type="date" className="fs-5 border-0" />
                  </div> */}
                </div>

                <div className="mb-3 row px-lg-4">
                  <label
                    htmlFor="name"
                    className="col-md-2 col-xxl-1 col-form-label"
                  >
                    <h5 className="text-secondary fw-bold">{this.props.t('Name')}</h5>
                  </label>
                  <div className="col-md-10 col-xxl-6">
                    <input
                      className="form-control fs-5"
                      type="text"
                      name="name"
                      placeholder="Rainbow Star"
                    />
                  </div>
                </div>
                <div className="mb-3 row px-lg-4">
                  <label
                    htmlFor="month"
                    className="col-md-2 col-xxl-1 col-form-label"
                  >
                    <h5 className="text-secondary fw-bold">Month</h5>
                  </label>
                  <div className="col-md-10 col-xxl-6">
                    <input
                      className="form-control fs-5"
                      type="text"
                      name="month"
                      placeholder="June - 2022"
                    />
                  </div>
                </div>

                <div className="pt-3 px-3">
                  <h4 className="fw-bold text-black py-3">
                    Entered Stock Summary
                  </h4>
                  <div className="table-responsive">
                    <table className="table table-bordered foo">
                      <thead className="background-light fs-5 fw-bold">
                        <tr>
                          <th>sr No.</th>
                          <th>Date</th>
                          <th>HPHT</th>
                          <th>LPHT</th>
                          <th>REAL</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody className="fs-5 foo">
                        <tr>
                          <td>01</td>
                          <td>31.5.22</td>
                          <td>6.470</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>02</td>
                          <td>1.6.22</td>
                          <td>6.470</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                      <tfoot className="table-light fs-5 fw-bold">
                        <tr>
                          <td>Total:</td>
                          <td></td>
                          <td>7.720</td>
                          <td>0.000</td>
                          <td>5.260</td>
                          <td>12.980</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div className="px-3 no-print">
                  <h4 className="fw-bold text-black pt-2">
                    Terms and Conditions
                  </h4>
                  <p className="fs-5 text-black">
                    (1) There is possibility of complete damage of the stone as
                    result of high pressure cell decompressing during HPHT run.
                    Probability of this situation is 3% per 100 Cycles. All risk
                    of goods being damaged during HPHT will be barred by
                    Customer.{" "}
                  </p>
                  <p className="fs-5 text-black">
                    (2) Out of the two copies of bill along with the goods,
                    kindly return one signed copy as an evidence of
                    acknowledgement received by you. Once the goods have been
                    received, Confirmed by signing Bill, no claim, arguments or
                    complaints shall be entertained regarding weight, purity,
                    charni, category and the Quality of the diamonds.
                  </p>
                  <p className="fs-5 text-black">
                    (3)Subject to Surat jurisdiction only.
                  </p>
                </div>
              </div>
            </Card>
            <div className="row my-5">
              <div className="col-12 text-end">
                <div className="btn-group">
                  <Button
                    color="primary"
                    className="fs-4 px-5"
                    type="submit"
                    onClick={e => window.print(e.preventDefault())}
                  >
                    Print
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default ExternalLedgerPrint;
